import * as React from 'react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'

import ConflictsTooltip from './ConflictsTooltip'
import PublishButton from './PublishButton'
import PublishModal from './PublishModal'
import usePublishShifts from './usePublishShifts'

interface Props {
  contractVersions: ContractVersions
}

const Publish = ({ contractVersions }: Props) => {
  const { submitting, showPublishModal, onConfirm, togglePublishModal } =
    usePublishShifts(contractVersions)

  const onCloseModal = () => togglePublishModal(false)

  return (
    <>
      {showPublishModal && (
        <PublishModal onClose={onCloseModal} onConfirm={onConfirm} submitting={submitting} />
      )}
      <ConflictsTooltip>
        <PublishButton onClick={togglePublishModal} />
      </ConflictsTooltip>
    </>
  )
}

export default Publish
